const mode = 'prod'

export default function getImgUrl (url) {
  return mode === 'dev'
    ? `http://finwhale.ru${url}`
    : navigator.userAgent === "ReactSnap" ? `https://finwhale.${navigator.siteLanguage}` + url : url
}



// WEBPACK FOOTER //
// ./src/getImgUrl.js